export default "__VITE_ASSET__CDb4HYnz__"